import { LoadingButton, Section } from '@cmg/design-system';
import { useFormik } from 'formik';
import React, { useMemo } from 'react';

import { useIndicationSectionActions } from '../../hooks/useIndicationSectionActions';
import IndicationStatus from '../indication-status/IndicationStatus';

export type IndicationSectionWithCreateButtonsProps = {
  isLoading: boolean;
  handlePass: () => void;
  handleReset: ReturnType<typeof useFormik>['handleReset'];
  handleSubmit: () => void;
};

export const IndicationSectionWithCreateButtons: React.FC<
  React.PropsWithChildren<IndicationSectionWithCreateButtonsProps>
> = ({ children, isLoading, handlePass, handleReset, handleSubmit }) => {
  const indicationSectionActionsParams = useMemo(
    () => ({
      actions: [
        <LoadingButton key="pass" variant="outlined" disabled={isLoading} onClick={handlePass}>
          Pass
        </LoadingButton>,
        <LoadingButton key="discard" variant="outlined" disabled={isLoading} onClick={handleReset}>
          Discard Changes
        </LoadingButton>,
        <LoadingButton key="submit" variant="contained" loading={isLoading} onClick={handleSubmit}>
          Submit Indication
        </LoadingButton>,
      ],
      smallScreenActions: [
        <LoadingButton key="submit" variant="contained" loading={isLoading} onClick={handleSubmit}>
          Submit Indication
        </LoadingButton>,
      ],
      smallScreenContextMenuActions: [
        {
          key: 'pass',
          label: 'Pass',
          onClick: handlePass,
        },
        {
          key: 'discard',
          label: 'Discard Changes',
          onClick: handleReset,
        },
      ],
    }),
    [handlePass, handleReset, handleSubmit, isLoading]
  );
  const actions = useIndicationSectionActions(indicationSectionActionsParams);

  return (
    <Section
      data-testid="create-indication-view"
      title="Indication"
      titleItems={<IndicationStatus />}
      actions={actions}
    >
      {children}
    </Section>
  );
};
